<template>
  <v-tabs-items v-model="currentTab">
    <v-tab-item
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{ 'tab-item': true, embedded: isEmbedded }"
    >
      <v-container :class="{ 'pt-0': !isEmbedded, 'pa-0': isEmbedded }">
        <slot
          v-if="tab.idx == 0"
          name="firstTab"
          v-bind="{ tab, parentTab }"
        />

        <slot
          v-else
          name="form"
          v-bind="{ tab, parentTab }"
        />
      </v-container>
    </v-tab-item>
  </v-tabs-items>
</template>

<script>
export default {
  props: {
    value: Number,

    tabs: { type: Array, default: () => [] },

    // When the main component is embedded inside another tab
    parentTab: Object,

    // Force embedded mode
    embedded: Boolean,
  },

  data: () => ({
    currentTab: 0,
  }),

  computed: {
    isEmbedded() {
      return !_.isUndefined(this.parentTab) || this.embedded;
    },
  },

  watch: {
    value(newValue) {
      this.currentTab = newValue;
    },

    currentTab(newValue) {
      this.$emit('input', newValue);
    }
  },

  mounted() {
    this.currentTab = this.value;
  },
};
</script>

<style scoped>
.tab-item:not(.embedded) {
  background-color: #eee !important;
}
</style>
